import { StatusUnion, Status } from '~/common/types';

const colorMap: { [key in StatusUnion]?: 'error' | 'warning' | 'success' } = {
  [Status.ERROR]: 'error',
  [Status.SUCCESS]: 'success',
  [Status.WARNING]: 'warning',
};

export const colorFromStatus = (status?: StatusUnion | null): 'error' | 'warning' | 'success' | undefined => {
  return status ? colorMap[status] : undefined;
};
